module.exports = __webpack_public_path__ + "static/media/Werner Ave Daly City, CA (3 Houses)4.03f35166.jpg";